import React, {FC, useEffect, useState} from "react";
import * as Yup from "yup";
import {useFormik} from "formik";
import clsx from "clsx";
import {contact, getCountries} from "../../core/home/requests";
import Select from "react-select";
import Terms from "../modals/terms";
import PrivacyPolicy from "../modals/privacy-policy";
import {Link} from "react-router-dom";

const contactSchema = Yup.object().shape({
    email: Yup.string()
        .email("Wrong email format")
        .min(3, "Minimum 3 symbols")
        .max(50, "Maximum 50 symbols")
        .required("Email is required"),

    last_name: Yup.string()
        .required("First name is required"),

    client: Yup.string()
        .required("Client or AD is required"),

    first_name: Yup.string()
        .required("First name is required"),

    source_of_reference: Yup.string()
        .required("This is required"),
    agree: Yup.boolean()
        .oneOf([true], 'You must agree to the Privacy Policy'),

    agree1: Yup.boolean()
        .oneOf([true], 'This is required'),
    agree2: Yup.boolean(),
    agree3: Yup.boolean(),

});

const initialValues = {
    email: "",
    last_name: "",
    first_name : "",
    client: "",
    message: "",
    phoneNumber :"",
    country_id :"",
    agree: true,
    agree1: true,
    agree2: true,
    agree3: true,
    source_of_reference : ""
};

const options = [{"id":1,"name":"Client","slug":null},{"id":2,"name":"AD"}];
const optionsQusetion = [{"id":1,"name":"Downtown Design Fair","slug":null},{"id":2,"name":"Advertising"},{"id":3,"name":"Social Media"},{"id":4,"name":"Friends/Family"},{"id":5,"name":"Architect & Designer"}];

const countries = [{"id":1,"code":"US","name":"United States","slug":null},{"id":2,"code":"CA","name":"Canada","slug":null},{"id":3,"code":"AF","name":"Afghanistan","slug":null},{"id":4,"code":"AL","name":"Albania","slug":null},{"id":5,"code":"DZ","name":"Algeria","slug":null},{"id":6,"code":"AS","name":"American Samoa","slug":null},{"id":7,"code":"AD","name":"Andorra","slug":null},{"id":8,"code":"AO","name":"Angola","slug":null},{"id":9,"code":"AI","name":"Anguilla","slug":null},{"id":10,"code":"AQ","name":"Antarctica","slug":null},{"id":11,"code":"AG","name":"Antigua and\/or Barbuda","slug":null},{"id":12,"code":"AR","name":"Argentina","slug":null},{"id":13,"code":"AM","name":"Armenia","slug":null},{"id":14,"code":"AW","name":"Aruba","slug":null},{"id":15,"code":"AU","name":"Australia","slug":null},{"id":16,"code":"AT","name":"Austria","slug":null},{"id":17,"code":"AZ","name":"Azerbaijan","slug":null},{"id":18,"code":"BS","name":"Bahamas","slug":null},{"id":19,"code":"BH","name":"Bahrain","slug":null},{"id":20,"code":"BD","name":"Bangladesh","slug":null},{"id":21,"code":"BB","name":"Barbados","slug":null},{"id":22,"code":"BY","name":"Belarus","slug":null},{"id":23,"code":"BE","name":"Belgium","slug":null},{"id":24,"code":"BZ","name":"Belize","slug":null},{"id":25,"code":"BJ","name":"Benin","slug":null},{"id":26,"code":"BM","name":"Bermuda","slug":null},{"id":27,"code":"BT","name":"Bhutan","slug":null},{"id":28,"code":"BO","name":"Bolivia","slug":null},{"id":29,"code":"BA","name":"Bosnia and Herzegovina","slug":null},{"id":30,"code":"BW","name":"Botswana","slug":null},{"id":31,"code":"BV","name":"Bouvet Island","slug":null},{"id":32,"code":"BR","name":"Brazil","slug":null},{"id":33,"code":"IO","name":"British lndian Ocean Territory","slug":null},{"id":34,"code":"BN","name":"Brunei Darussalam","slug":null},{"id":35,"code":"BG","name":"Bulgaria","slug":null},{"id":36,"code":"BF","name":"Burkina Faso","slug":null},{"id":37,"code":"BI","name":"Burundi","slug":null},{"id":38,"code":"KH","name":"Cambodia","slug":null},{"id":39,"code":"CM","name":"Cameroon","slug":null},{"id":40,"code":"CV","name":"Cape Verde","slug":null},{"id":41,"code":"KY","name":"Cayman Islands","slug":null},{"id":42,"code":"CF","name":"Central African Republic","slug":null},{"id":43,"code":"TD","name":"Chad","slug":null},{"id":44,"code":"CL","name":"Chile","slug":null},{"id":45,"code":"CN","name":"China","slug":null},{"id":46,"code":"CX","name":"Christmas Island","slug":null},{"id":47,"code":"CC","name":"Cocos (Keeling) Islands","slug":null},{"id":48,"code":"CO","name":"Colombia","slug":null},{"id":49,"code":"KM","name":"Comoros","slug":null},{"id":50,"code":"CG","name":"Congo","slug":null},{"id":51,"code":"CK","name":"Cook Islands","slug":null},{"id":52,"code":"CR","name":"Costa Rica","slug":null},{"id":53,"code":"HR","name":"Croatia (Hrvatska)","slug":null},{"id":54,"code":"CU","name":"Cuba","slug":null},{"id":55,"code":"CY","name":"Cyprus","slug":null},{"id":56,"code":"CZ","name":"Czech Republic","slug":null},{"id":57,"code":"CD","name":"Democratic Republic of Congo","slug":null},{"id":58,"code":"DK","name":"Denmark","slug":null},{"id":59,"code":"DJ","name":"Djibouti","slug":null},{"id":60,"code":"DM","name":"Dominica","slug":null},{"id":61,"code":"DO","name":"Dominican Republic","slug":null},{"id":62,"code":"TP","name":"East Timor","slug":null},{"id":63,"code":"EC","name":"Ecudaor","slug":null},{"id":64,"code":"EG","name":"Egypt","slug":null},{"id":65,"code":"SV","name":"El Salvador","slug":null},{"id":66,"code":"GQ","name":"Equatorial Guinea","slug":null},{"id":67,"code":"ER","name":"Eritrea","slug":null},{"id":68,"code":"EE","name":"Estonia","slug":null},{"id":69,"code":"ET","name":"Ethiopia","slug":null},{"id":70,"code":"FK","name":"Falkland Islands (Malvinas)","slug":null},{"id":71,"code":"FO","name":"Faroe Islands","slug":null},{"id":72,"code":"FJ","name":"Fiji","slug":null},{"id":73,"code":"FI","name":"Finland","slug":null},{"id":74,"code":"FR","name":"France","slug":null},{"id":75,"code":"FX","name":"France, Metropolitan","slug":null},{"id":76,"code":"GF","name":"French Guiana","slug":null},{"id":77,"code":"PF","name":"French Polynesia","slug":null},{"id":78,"code":"TF","name":"French Southern Territories","slug":null},{"id":79,"code":"GA","name":"Gabon","slug":null},{"id":80,"code":"GM","name":"Gambia","slug":null},{"id":81,"code":"GE","name":"Georgia","slug":null},{"id":82,"code":"DE","name":"Germany","slug":null},{"id":83,"code":"GH","name":"Ghana","slug":null},{"id":84,"code":"GI","name":"Gibraltar","slug":null},{"id":85,"code":"GR","name":"Greece","slug":null},{"id":86,"code":"GL","name":"Greenland","slug":null},{"id":87,"code":"GD","name":"Grenada","slug":null},{"id":88,"code":"GP","name":"Guadeloupe","slug":null},{"id":89,"code":"GU","name":"Guam","slug":null},{"id":90,"code":"GT","name":"Guatemala","slug":null},{"id":91,"code":"GN","name":"Guinea","slug":null},{"id":92,"code":"GW","name":"Guinea-Bissau","slug":null},{"id":93,"code":"GY","name":"Guyana","slug":null},{"id":94,"code":"HT","name":"Haiti","slug":null},{"id":95,"code":"HM","name":"Heard and Mc Donald Islands","slug":null},{"id":96,"code":"HN","name":"Honduras","slug":null},{"id":97,"code":"HK","name":"Hong Kong","slug":null},{"id":98,"code":"HU","name":"Hungary","slug":null},{"id":99,"code":"IS","name":"Iceland","slug":null},{"id":100,"code":"IN","name":"India","slug":null},{"id":101,"code":"ID","name":"Indonesia","slug":null},{"id":102,"code":"IR","name":"Iran (Islamic Republic of)","slug":null},{"id":103,"code":"IQ","name":"Iraq","slug":null},{"id":104,"code":"IE","name":"Ireland","slug":null},{"id":105,"code":"IT","name":"Italy","slug":null},{"id":106,"code":"CI","name":"Ivory Coast","slug":null},{"id":107,"code":"JM","name":"Jamaica","slug":null},{"id":108,"code":"JP","name":"Japan","slug":null},{"id":109,"code":"JO","name":"Jordan","slug":null},{"id":110,"code":"KZ","name":"Kazakhstan","slug":null},{"id":111,"code":"KE","name":"Kenya","slug":null},{"id":112,"code":"KI","name":"Kiribati","slug":null},{"id":113,"code":"KP","name":"Korea, Democratic People's Republic of","slug":null},{"id":114,"code":"KR","name":"Korea, Republic of","slug":null},{"id":115,"code":"KW","name":"Kuwait","slug":null},{"id":116,"code":"KG","name":"Kyrgyzstan","slug":null},{"id":117,"code":"LA","name":"Lao People's Democratic Republic","slug":null},{"id":118,"code":"LV","name":"Latvia","slug":null},{"id":119,"code":"LB","name":"Lebanon","slug":null},{"id":120,"code":"LS","name":"Lesotho","slug":null},{"id":121,"code":"LR","name":"Liberia","slug":null},{"id":122,"code":"LY","name":"Libyan Arab Jamahiriya","slug":null},{"id":123,"code":"LI","name":"Liechtenstein","slug":null},{"id":124,"code":"LT","name":"Lithuania","slug":null},{"id":125,"code":"LU","name":"Luxembourg","slug":null},{"id":126,"code":"MO","name":"Macau","slug":null},{"id":127,"code":"MK","name":"Macedonia","slug":null},{"id":128,"code":"MG","name":"Madagascar","slug":null},{"id":129,"code":"MW","name":"Malawi","slug":null},{"id":130,"code":"MY","name":"Malaysia","slug":null},{"id":131,"code":"MV","name":"Maldives","slug":null},{"id":132,"code":"ML","name":"Mali","slug":null},{"id":133,"code":"MT","name":"Malta","slug":null},{"id":134,"code":"MH","name":"Marshall Islands","slug":null},{"id":135,"code":"MQ","name":"Martinique","slug":null},{"id":136,"code":"MR","name":"Mauritania","slug":null},{"id":137,"code":"MU","name":"Mauritius","slug":null},{"id":138,"code":"TY","name":"Mayotte","slug":null},{"id":139,"code":"MX","name":"Mexico","slug":null},{"id":140,"code":"FM","name":"Micronesia, Federated States of","slug":null},{"id":141,"code":"MD","name":"Moldova, Republic of","slug":null},{"id":142,"code":"MC","name":"Monaco","slug":null},{"id":143,"code":"MN","name":"Mongolia","slug":null},{"id":144,"code":"MS","name":"Montserrat","slug":null},{"id":145,"code":"MA","name":"Morocco","slug":null},{"id":146,"code":"MZ","name":"Mozambique","slug":null},{"id":147,"code":"MM","name":"Myanmar","slug":null},{"id":148,"code":"NA","name":"Namibia","slug":null},{"id":149,"code":"NR","name":"Nauru","slug":null},{"id":150,"code":"NP","name":"Nepal","slug":null},{"id":151,"code":"NL","name":"Netherlands","slug":null},{"id":152,"code":"AN","name":"Netherlands Antilles","slug":null},{"id":153,"code":"NC","name":"New Caledonia","slug":null},{"id":154,"code":"NZ","name":"New Zealand","slug":null},{"id":155,"code":"NI","name":"Nicaragua","slug":null},{"id":156,"code":"NE","name":"Niger","slug":null},{"id":157,"code":"NG","name":"Nigeria","slug":null},{"id":158,"code":"NU","name":"Niue","slug":null},{"id":159,"code":"NF","name":"Norfork Island","slug":null},{"id":160,"code":"MP","name":"Northern Mariana Islands","slug":null},{"id":161,"code":"NO","name":"Norway","slug":null},{"id":162,"code":"OM","name":"Oman","slug":null},{"id":163,"code":"PK","name":"Pakistan","slug":null},{"id":164,"code":"PW","name":"Palau","slug":null},{"id":165,"code":"PA","name":"Panama","slug":null},{"id":166,"code":"PG","name":"Papua New Guinea","slug":null},{"id":167,"code":"PY","name":"Paraguay","slug":null},{"id":168,"code":"PE","name":"Peru","slug":null},{"id":169,"code":"PH","name":"Philippines","slug":null},{"id":170,"code":"PN","name":"Pitcairn","slug":null},{"id":171,"code":"PL","name":"Poland","slug":null},{"id":172,"code":"PT","name":"Portugal","slug":null},{"id":173,"code":"PR","name":"Puerto Rico","slug":null},{"id":174,"code":"QA","name":"Qatar","slug":null},{"id":175,"code":"SS","name":"Republic of South Sudan","slug":null},{"id":176,"code":"RE","name":"Reunion","slug":null},{"id":177,"code":"RO","name":"Romania","slug":null},{"id":178,"code":"RU","name":"Russian Federation","slug":null},{"id":179,"code":"RW","name":"Rwanda","slug":null},{"id":180,"code":"KN","name":"Saint Kitts and Nevis","slug":null},{"id":181,"code":"LC","name":"Saint Lucia","slug":null},{"id":182,"code":"VC","name":"Saint Vincent and the Grenadines","slug":null},{"id":183,"code":"WS","name":"Samoa","slug":null},{"id":184,"code":"SM","name":"San Marino","slug":null},{"id":185,"code":"ST","name":"Sao Tome and Principe","slug":null},{"id":186,"code":"SA","name":"Saudi Arabia","slug":null},{"id":187,"code":"SN","name":"Senegal","slug":null},{"id":188,"code":"RS","name":"Serbia","slug":null},{"id":189,"code":"SC","name":"Seychelles","slug":null},{"id":190,"code":"SL","name":"Sierra Leone","slug":null},{"id":191,"code":"SG","name":"Singapore","slug":null},{"id":192,"code":"SK","name":"Slovakia","slug":null},{"id":193,"code":"SI","name":"Slovenia","slug":null},{"id":194,"code":"SB","name":"Solomon Islands","slug":null},{"id":195,"code":"SO","name":"Somalia","slug":null},{"id":196,"code":"ZA","name":"South Africa","slug":null},{"id":197,"code":"GS","name":"South Georgia South Sandwich Islands","slug":null},{"id":198,"code":"ES","name":"Spain","slug":null},{"id":199,"code":"LK","name":"Sri Lanka","slug":null},{"id":200,"code":"SH","name":"St. Helena","slug":null},{"id":201,"code":"PM","name":"St. Pierre and Miquelon","slug":null},{"id":202,"code":"SD","name":"Sudan","slug":null},{"id":203,"code":"SR","name":"Suriname","slug":null},{"id":204,"code":"SJ","name":"Svalbarn and Jan Mayen Islands","slug":null},{"id":205,"code":"SZ","name":"Swaziland","slug":null},{"id":206,"code":"SE","name":"Sweden","slug":null},{"id":207,"code":"CH","name":"Switzerland","slug":null},{"id":208,"code":"SY","name":"Syrian Arab Republic","slug":null},{"id":209,"code":"TW","name":"Taiwan","slug":null},{"id":210,"code":"TJ","name":"Tajikistan","slug":null},{"id":211,"code":"TZ","name":"Tanzania, United Republic of","slug":null},{"id":212,"code":"TH","name":"Thailand","slug":null},{"id":213,"code":"TG","name":"Togo","slug":null},{"id":214,"code":"TK","name":"Tokelau","slug":null},{"id":215,"code":"TO","name":"Tonga","slug":null},{"id":216,"code":"TT","name":"Trinidad and Tobago","slug":null},{"id":217,"code":"TN","name":"Tunisia","slug":null},{"id":218,"code":"TR","name":"Turkey","slug":null},{"id":219,"code":"TM","name":"Turkmenistan","slug":null},{"id":220,"code":"TC","name":"Turks and Caicos Islands","slug":null},{"id":221,"code":"TV","name":"Tuvalu","slug":null},{"id":222,"code":"UG","name":"Uganda","slug":null},{"id":223,"code":"UA","name":"Ukraine","slug":null},{"id":224,"code":"AE","name":"United Arab Emirates","slug":null},{"id":225,"code":"GB","name":"United Kingdom","slug":null},{"id":226,"code":"UM","name":"United States minor outlying islands","slug":null},{"id":227,"code":"UY","name":"Uruguay","slug":null},{"id":228,"code":"UZ","name":"Uzbekistan","slug":null},{"id":229,"code":"VU","name":"Vanuatu","slug":null},{"id":230,"code":"VA","name":"Vatican City State","slug":null},{"id":231,"code":"VE","name":"Venezuela","slug":null},{"id":232,"code":"VN","name":"Vietnam","slug":null},{"id":233,"code":"VG","name":"Virgin Islands (British)","slug":null},{"id":234,"code":"VI","name":"Virgin Islands (U.S.)","slug":null},{"id":235,"code":"WF","name":"Wallis and Futuna Islands","slug":null},{"id":236,"code":"EH","name":"Western Sahara","slug":null},{"id":237,"code":"YE","name":"Yemen","slug":null},{"id":238,"code":"YU","name":"Yugoslavia","slug":null},{"id":239,"code":"ZR","name":"Zaire","slug":null},{"id":240,"code":"ZM","name":"Zambia","slug":null},{"id":241,"code":"ZW","name":"Zimbabwe","slug":null}]
const ContactForm: FC = () => {
    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [agree, setAgree] = useState(true);
    const [agree1, setAgree1] = useState(true);
    const [agree2, setAgree2] = useState(true);
    const [agree3, setAgree3] = useState(true);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow(false);
    const handleShow2 = () => setShow(true);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const formik = useFormik({
        initialValues,
        validationSchema: contactSchema,
        onSubmit: async (values, { setSubmitting }) => {

            setErrorMessage(false)
            setSubmitting(true);
            try {
                setLoading(true);

                const { data } = await contact(values);

                if (data === 1) {
                    setLoading(false);
                    setIsActive(true);
                    // formik.resetForm();
                    setTimeout(function () {
                        setIsActive(false);
                        // resetForm()
                    }, 2500);
                }else{

                    setErrorMessage(true)

                }
            } catch (ex) {
                console.error(ex);
            } finally {
                setSubmitting(true);
                setLoading(false);
            }
        },
    });

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };
    const openModal2 = () => {
        setModalIsOpen2(true);
    };

    const closeModal2 = () => {
        setModalIsOpen2(false);
    };


    useEffect(() => {




    }, [])
    return (

        <div className={'container'}>
            <div className="row justify-content-center">

                {isActive && (
                    <div className="col-md-10 ">
                        <div className="alert-box contact-alert mt-5">
                            <div className="alert alert-success alert-dismissible" role="alert">
                                Thank you for submitting the form!
                            </div>
                        </div>
                    </div>
                )
                }

                {errorMessage && (
                    <div className="col-md-10 ">
                        <div className="alert-box contact-alert mt-5">
                            <div className="alert alert-danger alert-dismissible" role="alert">
                                You've already registered
                            </div>
                        </div>
                    </div>
                )
                }
                <div className={'col-md-10 mt-5 '}>
                    <form className="contact-form " onSubmit={formik.handleSubmit} noValidate>
                        <div className="row justify-content-center">
                            <div className="form-group row">
                                <div className={'col-md-12'}>

                                    <input
                                        className={clsx(
                                            "form-control", {
                                                "is-invalid":
                                                    formik.touched.first_name && formik.errors.first_name,
                                            },
                                            {
                                                "is-valid":
                                                    formik.touched.first_name && !formik.errors.first_name,
                                            })}
                                        type="text" placeholder={'First Name'} required {...formik.getFieldProps("first_name")}
                                    />
                                    {formik.touched.first_name && formik.errors.first_name && (
                                        <div className='invalid-feedback d-block'>
                                                                            <span
                                                                                role='alert'>{formik.errors.first_name}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="form-group row mt-4">
                                <div className={'col-md-12'}>

                                    <input
                                        className={clsx(
                                            "form-control", {
                                                "is-invalid":
                                                    formik.touched.last_name && formik.errors.last_name,
                                            },
                                            {
                                                "is-valid":
                                                    formik.touched.last_name && !formik.errors.last_name,
                                            })}
                                        type="text" placeholder={'Last Name'}  required {...formik.getFieldProps("last_name")}
                                    />
                                    {formik.touched.last_name && formik.errors.last_name && (
                                        <div className='invalid-feedback d-block'>
                                                                            <span
                                                                                role='alert'>{formik.errors.last_name}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="form-group row mt-4">
                                <div className={'col-md-12'}>

                                    <input
                                        className={clsx(
                                            "form-control", {
                                                "is-invalid":
                                                    formik.touched.email && formik.errors.email,
                                            },
                                            {
                                                "is-valid":
                                                    formik.touched.email && !formik.errors.email,
                                            })}
                                        type="text" placeholder={'Email'}  required {...formik.getFieldProps("email")}
                                    />
                                    {formik.touched.email && formik.errors.email && (
                                        <div className='invalid-feedback d-block'>
                                                                            <span
                                                                                role='alert'>{formik.errors.email}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="form-group row mt-4">
                                <div className={'col-md-12'}>

                                    <input
                                        className={
                                            "form-control"}
                                        type="text" placeholder={'Phone Number'}  required {...formik.getFieldProps("phoneNumber")}
                                    />

                                </div>
                            </div>
                            <div className="form-group row mt-4">
                                <div className={'col-md-12  mb-2'}>
                                    <Select
                                        className={clsx(
                                            "w-100 ",
                                        )}
                                        closeMenuOnSelect={false}
                                        placeholder={"Client or AD"}
                                        options={options.map((e: {
                                            name: any;
                                            id: any
                                        }) => ({label: e.name, value: e.id}))}
                                        isSearchable={true}
                                        onChange={(newValue: any) =>
                                            formik.setFieldValue('client', newValue.value)
                                        }
                                    />
                                    {formik.touched.client && formik.errors.client && (
                                        <div className='invalid-feedback d-block'>
                                                                            <span
                                                                                role='alert'>Client is required</span>
                                        </div>
                                    )}


                                </div>
                            </div>
                            <div className="form-group row mt-4">
                                <div className={'col-md-12  mb-2'}>
                                    <Select
                                        className={clsx(
                                            "w-100 ",
                                        )}
                                        closeMenuOnSelect={false}
                                        placeholder={"How did you hear about Cassina?\n"}
                                        options={optionsQusetion.map((e: {
                                            name: any;
                                            id: any
                                        }) => ({label: e.name, value: e.id}))}
                                        isSearchable={true}
                                        onChange={(newValue: any) =>
                                            formik.setFieldValue('source_of_reference', newValue.value)
                                        }
                                    />
                                    {formik.touched.source_of_reference && formik.errors.source_of_reference && (
                                        <div className='invalid-feedback d-block'>
                                                                            <span
                                                                                role='alert'>This is required</span>
                                        </div>
                                    )}


                                </div>
                            </div>

                            <div className="form-group row mt-4">
                                <div className={'col-md-12  mb-2'}>
                                    <Select
                                        className={clsx(
                                            "w-100 ",
                                        )}
                                        closeMenuOnSelect={false}
                                        placeholder={"Nationality"}
                                        options={countries.map((e: {
                                            name: any;
                                            id: any
                                        }) => ({label: e.name, value: e.id}))}
                                        isSearchable={true}
                                        onChange={(newValue: any) =>
                                            formik.setFieldValue('country_id', newValue.value)
                                        }
                                    />



                                </div>
                            </div>
                            <div className={'form-group row mt-4'}>
                                <div className={'col-md-12'}>
                                    <input
                                        type="checkbox"
                                        checked={agree}
                                        onChange={(e) => {
                                            setAgree(e.target.checked);
                                            formik.setFieldValue('agree', e.target.checked);}}
                                    />
                                    <span className={'terms-condition ms-3'}>I agree to <Link
                                        to={'#'} onClick={openModal2}>Privacy Policy</Link> </span>
                                </div>

                                {formik.errors.agree && formik.touched.agree && (
                                    <div className="invalid-feedback d-block">{formik.errors.agree}</div>
                                )}
                            </div>

                            <div className={'form-group row '}>
                                <div className={'col-md-12'}>
                                    <input
                                        type="checkbox"
                                        checked={agree1}
                                        onChange={(e) => {
                                            setAgree1(e.target.checked);
                                            formik.setFieldValue('agree1', e.target.checked);}}
                                    />
                                    <span className={'terms-condition ms-3'}>I have read and understood the privacy notice on the processing of my data, and I confirm that I am over 18. </span>
                                </div>

                                {formik.errors.agree1 && formik.touched.agree1 && (
                                    <div className="invalid-feedback d-block">{formik.errors.agree1}</div>
                                )}
                            </div>
                            <div className={'form-group row'}>
                                <div className={'col-md-12'}>
                                    <input
                                        type="checkbox"
                                        checked={agree2}
                                        onChange={(e) => {
                                            setAgree2(e.target.checked);
                                            formik.setFieldValue('agree2', e.target.checked);}}
                                    />
                                    <span className={'terms-condition ms-3'}>I consent to the processing of my data to receive marketing information and updates about collections, exhibitions, events, and to participate in customer satisfaction surveys and market research for the improvement of products and services (by newsletter, email, or telephone, or by automated means – SMS, messaging systems). </span>
                                </div>

                                {formik.errors.agree2 && formik.touched.agree2 && (
                                    <div className="invalid-feedback d-block">{formik.errors.agree2}</div>
                                )}
                            </div>
                            <div className={'form-group row'}>
                                <div className={'col-md-12'}>
                                    <input
                                        type="checkbox"
                                        checked={agree3}
                                        onChange={(e) => {
                                            setAgree3(e.target.checked);
                                            formik.setFieldValue('agree3', e.target.checked);}}
                                    />
                                    <span className={'terms-condition ms-3'}>I consent to the communication of my Data to Vivium Living, so that the latter can send me marketing information and updates about collections, exhibitions, and other institutional information, including through newsletters in relation to its products and services, and to participate in any customer satisfaction surveys and market research to improve the product. </span>
                                </div>

                                {formik.errors.agree3 && formik.touched.agree3 && (
                                    <div className="invalid-feedback d-block">{formik.errors.agree3}</div>
                                )}
                            </div>
                        </div>


                        <div className={'form-group row mt-4 mb-4'}>
                        <div className="col-md-4 ">
                            <button
                                className="btn btn-main w-100"
                                disabled={formik.isSubmitting }
                                type="submit"
                            >
                                {!loading && (
                                    <span className="indicator-label">
                               Submit    </span>
                                )}
                                {loading && (
                                    <span
                                        className="indicator-progress"
                                        style={{display: "block"}}
                                    >
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                )}
                            </button>

                        </div>
                        </div>

                    </form>
                </div>



                <Terms isOpen={modalIsOpen} onClose={closeModal} />

                <PrivacyPolicy isOpen={modalIsOpen2} onClose={closeModal2} />
            </div>
        </div>


    );
}

export default ContactForm;